export default[
  {
    "id": 483386944,
    "node_id": "R_kgDOHM_mQA",
    "name": "Discord_bot_python",
    "full_name": "WhiteWolfWCY/Discord_bot_python",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/Discord_bot_python",
    "description": "Simple discord bot written in Python.",
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/Discord_bot_python/deployments",
    "created_at": "2022-04-19T19:44:33Z",
    "updated_at": "2022-04-19T21:33:10Z",
    "pushed_at": "2022-04-19T19:45:13Z",
    "git_url": "git://github.com/WhiteWolfWCY/Discord_bot_python.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/Discord_bot_python.git",
    "clone_url": "https://github.com/WhiteWolfWCY/Discord_bot_python.git",
    "svn_url": "https://github.com/WhiteWolfWCY/Discord_bot_python",
    "homepage": null,
    "size": 0,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 737799950,
    "node_id": "R_kgDOK_nvDg",
    "name": "github-users-explorer",
    "full_name": "WhiteWolfWCY/github-users-explorer",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/github-users-explorer",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/github-users-explorer/deployments",
    "created_at": "2024-01-01T14:49:50Z",
    "updated_at": "2024-01-01T14:50:40Z",
    "pushed_at": "2024-01-01T16:06:11Z",
    "git_url": "git://github.com/WhiteWolfWCY/github-users-explorer.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/github-users-explorer.git",
    "clone_url": "https://github.com/WhiteWolfWCY/github-users-explorer.git",
    "svn_url": "https://github.com/WhiteWolfWCY/github-users-explorer",
    "homepage": null,
    "size": 440,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 717015330,
    "node_id": "R_kgDOKrzJIg",
    "name": "JavaEE_Lab1",
    "full_name": "WhiteWolfWCY/JavaEE_Lab1",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/JavaEE_Lab1",
    "description": "Exercise 1 for Java Technologies EE Laboratories",
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/JavaEE_Lab1/deployments",
    "created_at": "2023-11-10T11:13:54Z",
    "updated_at": "2023-11-10T11:54:04Z",
    "pushed_at": "2023-11-10T14:01:54Z",
    "git_url": "git://github.com/WhiteWolfWCY/JavaEE_Lab1.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/JavaEE_Lab1.git",
    "clone_url": "https://github.com/WhiteWolfWCY/JavaEE_Lab1.git",
    "svn_url": "https://github.com/WhiteWolfWCY/JavaEE_Lab1",
    "homepage": null,
    "size": 3879,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 735073783,
    "node_id": "R_kgDOK9BV9w",
    "name": "nextjs-portfolio",
    "full_name": "WhiteWolfWCY/nextjs-portfolio",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/nextjs-portfolio",
    "description": "Personal portfolio website built using NextJS",
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/nextjs-portfolio/deployments",
    "created_at": "2023-12-23T15:13:41Z",
    "updated_at": "2023-12-26T21:47:23Z",
    "pushed_at": "2023-12-28T00:29:02Z",
    "git_url": "git://github.com/WhiteWolfWCY/nextjs-portfolio.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/nextjs-portfolio.git",
    "clone_url": "https://github.com/WhiteWolfWCY/nextjs-portfolio.git",
    "svn_url": "https://github.com/WhiteWolfWCY/nextjs-portfolio",
    "homepage": "https://nextjs-portfolio-nu-vert-53.vercel.app",
    "size": 45573,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 733028423,
    "node_id": "R_kgDOK7EgRw",
    "name": "PersonalTaskManager",
    "full_name": "WhiteWolfWCY/PersonalTaskManager",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/PersonalTaskManager",
    "description": "TypeScript + React to-do application",
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManager/deployments",
    "created_at": "2023-12-18T12:00:16Z",
    "updated_at": "2023-12-18T12:32:36Z",
    "pushed_at": "2023-12-23T00:26:44Z",
    "git_url": "git://github.com/WhiteWolfWCY/PersonalTaskManager.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/PersonalTaskManager.git",
    "clone_url": "https://github.com/WhiteWolfWCY/PersonalTaskManager.git",
    "svn_url": "https://github.com/WhiteWolfWCY/PersonalTaskManager",
    "homepage": null,
    "size": 757,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 734850636,
    "node_id": "R_kgDOK8zuTA",
    "name": "PersonalTaskManagerAPI",
    "full_name": "WhiteWolfWCY/PersonalTaskManagerAPI",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/PersonalTaskManagerAPI",
    "description": "Node API created to use with front-end todo application (PersonalTaskManager)",
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/PersonalTaskManagerAPI/deployments",
    "created_at": "2023-12-22T20:03:24Z",
    "updated_at": "2023-12-22T20:04:18Z",
    "pushed_at": "2023-12-22T20:04:15Z",
    "git_url": "git://github.com/WhiteWolfWCY/PersonalTaskManagerAPI.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/PersonalTaskManagerAPI.git",
    "clone_url": "https://github.com/WhiteWolfWCY/PersonalTaskManagerAPI.git",
    "svn_url": "https://github.com/WhiteWolfWCY/PersonalTaskManagerAPI",
    "homepage": null,
    "size": 3,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "TypeScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 424309220,
    "node_id": "R_kgDOGUpx5A",
    "name": "WDI_LABS",
    "full_name": "WhiteWolfWCY/WDI_LABS",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/WDI_LABS",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/WDI_LABS/deployments",
    "created_at": "2021-11-03T16:54:39Z",
    "updated_at": "2022-04-19T21:33:56Z",
    "pushed_at": "2022-01-31T17:01:02Z",
    "git_url": "git://github.com/WhiteWolfWCY/WDI_LABS.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/WDI_LABS.git",
    "clone_url": "https://github.com/WhiteWolfWCY/WDI_LABS.git",
    "svn_url": "https://github.com/WhiteWolfWCY/WDI_LABS",
    "homepage": null,
    "size": 603,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 488163582,
    "node_id": "R_kgDOHRjI_g",
    "name": "WDP_LABS",
    "full_name": "WhiteWolfWCY/WDP_LABS",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/WDP_LABS",
    "description": "Zadania realizowane na potrzeby przedmiotu \"Wprowadzenie do programowania\" w języku ANSI C",
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/WDP_LABS/deployments",
    "created_at": "2022-05-03T10:24:13Z",
    "updated_at": "2022-05-03T10:24:18Z",
    "pushed_at": "2022-05-03T10:24:15Z",
    "git_url": "git://github.com/WhiteWolfWCY/WDP_LABS.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/WDP_LABS.git",
    "clone_url": "https://github.com/WhiteWolfWCY/WDP_LABS.git",
    "svn_url": "https://github.com/WhiteWolfWCY/WDP_LABS",
    "homepage": null,
    "size": 4,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  },
  {
    "id": 483383538,
    "node_id": "R_kgDOHM_Y8g",
    "name": "whitebreakh_badacz",
    "full_name": "WhiteWolfWCY/whitebreakh_badacz",
    "private": false,
    "owner": {
      "login": "WhiteWolfWCY",
      "id": 52237339,
      "node_id": "MDQ6VXNlcjUyMjM3MzM5",
      "avatar_url": "https://avatars.githubusercontent.com/u/52237339?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/WhiteWolfWCY",
      "html_url": "https://github.com/WhiteWolfWCY",
      "followers_url": "https://api.github.com/users/WhiteWolfWCY/followers",
      "following_url": "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
      "gists_url": "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/WhiteWolfWCY/subscriptions",
      "organizations_url": "https://api.github.com/users/WhiteWolfWCY/orgs",
      "repos_url": "https://api.github.com/users/WhiteWolfWCY/repos",
      "events_url": "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
      "received_events_url": "https://api.github.com/users/WhiteWolfWCY/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/WhiteWolfWCY/whitebreakh_badacz",
    "description": "LUA script written to work on FiveM RP servers.",
    "fork": false,
    "url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz",
    "forks_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/forks",
    "keys_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/teams",
    "hooks_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/hooks",
    "issue_events_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/issues/events{/number}",
    "events_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/events",
    "assignees_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/assignees{/user}",
    "branches_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/branches{/branch}",
    "tags_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/tags",
    "blobs_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/languages",
    "stargazers_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/stargazers",
    "contributors_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/contributors",
    "subscribers_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/subscribers",
    "subscription_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/subscription",
    "commits_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/contents/{+path}",
    "compare_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/merges",
    "archive_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/downloads",
    "issues_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/issues{/number}",
    "pulls_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/labels{/name}",
    "releases_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/releases{/id}",
    "deployments_url": "https://api.github.com/repos/WhiteWolfWCY/whitebreakh_badacz/deployments",
    "created_at": "2022-04-19T19:32:43Z",
    "updated_at": "2022-04-19T21:33:36Z",
    "pushed_at": "2022-04-19T19:34:49Z",
    "git_url": "git://github.com/WhiteWolfWCY/whitebreakh_badacz.git",
    "ssh_url": "git@github.com:WhiteWolfWCY/whitebreakh_badacz.git",
    "clone_url": "https://github.com/WhiteWolfWCY/whitebreakh_badacz.git",
    "svn_url": "https://github.com/WhiteWolfWCY/whitebreakh_badacz",
    "homepage": null,
    "size": 4,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Lua",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "has_discussions": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "allow_forking": true,
    "is_template": false,
    "web_commit_signoff_required": false,
    "topics": [

    ],
    "visibility": "public",
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "main"
  }
]